import type { WordpressTaxonomy } from "@gik/core/models/wordpress/WordpressTaxonomy";
import type { UIComponent } from "@gik/core/types/UI";
import bemBlock from "@gik/core/utils/bemBlock";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import type React from "react";
import { useTranslation } from "react-i18next";
import translationKeys from "../../i18n/en";
import { RecipientsGridWithData } from "../RecipientsGrid";

export type ByRecipientSectionProps = {
	title?: string;
	fallbackData?: WordpressTaxonomy[];
} & UIComponent;

export function ByRecipientSection({
	className,
	title,
	fallbackData,
}: ByRecipientSectionProps): React.ReactElement {
	const bem = bemBlock("by-recipient-section");
	const { t } = useTranslation();

	return (
		<PageSection className={bem(null, null, className)}>
			<h2 className="gik-give-section-title">
				{title || t(translationKeys.byRecipientTitle)}
			</h2>
			<RecipientsGridWithData items={fallbackData} />
		</PageSection>
	);
}
